<!-- eslint-disable no-console -->
<template>
  <div class="form-group" :class="type === 2 ? 'form-group-2' : ''">
    <div class="form-title">{{ title }}</div>
    <slot />
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    type: { // 1 小框 2 大框
      type: Number,
      default: 1
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: () => ({
  }),
  methods: {
  },
}
</script>
<style lang="less" scoped>
.form-group {
  width: 1440px;
  height: 600px;
  margin: 0 auto;
  margin-top: -40px;
  background: url(~@/assets/result/result-bg-1.png) no-repeat;
  background-size: 100% 100%;
  padding: 60px 206px 106px;
  transform: scale(0.8);
  transform-origin: top;
  &-2 {
    background: url(~@/assets/result/result-bg-2.png) no-repeat;
    background-size: 100% 100%;
    padding: 60px 206px 25px;
    height: 600px;
  }
  .form-title {
    width: 327px;
    height: 72px;
    margin: 0 auto;
    margin-top: -34px;
    line-height: 72px;
    text-align: center;
    color: #fff;
    font-size: 33px;
    font-weight: 900;
    font-family: 'Alibaba-PuHuiTi';
  }
}
</style>